import React, { useEffect, useState } from "react";
import "../product-management.scss";
import { SearchBar } from "components/form";
import useDebounce from "common/UseDebounce";
import { useSearchParams } from "react-router-dom";
import {
  productListApi,
  productTypeListApi,
} from "services/product-management";
import Pagination from "react-js-pagination";
import NotFound from "common/NotFound";
import findSerialNumber from "utils/findSerialNumber";
import { FaEdit, FaTrash } from "react-icons/fa";
import useFullPageLoader from "common/UseFullPageLoader";
import DeleteProductType from "./DeleteProductType";
import AddNewProductType from "./AddProductType";
import EditProductType from "./EditProductType";
import { Select } from "common/InputForm";

const ProductTypeComponent = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedProductDetail, setSelectedProductDetail] = useState({});

  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  // const statusIns = searchParams.get("status") || "";

  const search = searchParams.get("search") || "";
  const debouncedValue = useDebounce(search, 300);

  const [fetchedData, setFetchedData] = useState([]);
  const [total, setTotal] = useState(null);

  //*********Handel Pagination********* */

  const handlePageChange = (event) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", event);
    setSearchParams(newParams);
  };

  const fetchProductList = async () => {
    const query = {
      page: activePage,
      limit,
      // status: statusIns,
    };

    if (search && debouncedValue) {
      query.search = search;
    }

    try {
      onShow();
      const {
        data: {
          code,
          status,
          data: { total, data },
        },
      } = await productTypeListApi(query);

      if (code === 200 || status) {
        setFetchedData(data);
        setTotal(total);
      }
    } catch (error) {
      console.log(error);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchProductList();
  }, [activePage, limit, debouncedValue]);

  const [addNewProductTypeState, setAddNewProductTypeState] = useState(false);

  const [editNewProductTypeState, setEditNewProductTypeState] = useState(false);

  const closeModel = () => {
    setDeleteModal(false);
    setSelectedProductDetail({});
    setAddNewProductTypeState(false);
    setEditNewProductTypeState(false);
  };

  // ----------add new product

  // Sanitize search input (catches paste, drag-drop, autofill):
  // 1. Strip characters that could break the URL/query or enable injection.
  // 2. Collapse any repeated hyphens down to a single "-".
  const sanitizeSearchValue = (value) => {
    let sanitized = value.replace(/[<>"'`;\\{}[\]]/g, "");
    sanitized = sanitized.replace(/-{2,}/g, "-");
    return sanitized;
  };

  // Block a second consecutive "-" from ever being typed
  // (catches the case onChange-only sanitization can visually miss).
  const handleSearchKeyDown = (e) => {
    if (e.key !== "-") return;

    const input = e.target;
    const cursorPos = input.selectionStart;
    const charBeforeCursor = input.value[cursorPos - 1];

    if (charBeforeCursor === "-") {
      e.preventDefault();
    }
  };

  return (
    <div className="productType-container">
      {loader}
      {/* --------add button */}
      <div className="add-button-container">
        <button
          type="button"
          className="button"
          onClick={() => {
            setAddNewProductTypeState(true);
          }}
        >
          Add Products
        </button>
      </div>
      {/* --------search box */}
      <div className="search-type-input">
        <div className="search_wrapper">
          <SearchBar
            placeholder={"Search..."}
            onKeyDown={handleSearchKeyDown}
            onChange={(e) => {
              const sanitizedValue = sanitizeSearchValue(e.target.value);

              const searchIns = new URLSearchParams(searchParams);
              searchIns.set("search", sanitizedValue);
              searchIns.set("page", 1);
              setSearchParams(searchIns);
            }}
            value={search}
          />

          {/* <div>
            <Select
              value={statusIns}
              onChange={(e) => {
                const urlInstance = new URLSearchParams(searchParams);
                urlInstance.set("status", e.target.value);
                urlInstance.set("page", 1);
                setSearchParams(urlInstance);
              }}
            >
              <option value="">Select Status</option>
              {[
                { value: "APPROVED", name: "Approved" },
                { value: "PENDING", name: "Pending" },
                { value: "REJECTED", name: "Rejected" },
                { value: "RESOLVED", name: "Resolve" },
              ].map((optionProp, ind) => (
                <option value={optionProp.value} key={ind}>
                  {optionProp.name}
                </option>
              ))}
            </Select>
          </div> */}
        </div>
      </div>

      {/* ------product---card starts */}

      {/* -------table-list -container */}

      <div className="table-container">
        <table className="table custom_table">
          <thead>
            <tr>
              <th className="nowrap text-center">S.No</th>
              <th className="nowrap text-center">Name</th>
              <th className="nowrap text-center">Discount</th>
              <th className="nowrap text-center">No. Of Products</th>
              <th className="nowrap text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {fetchedData && fetchedData.length > 0 ? (
              fetchedData?.map((mapProp, index) => {
                return (
                  <tr key={index}>
                    <td className="nowrap text-center">
                      {findSerialNumber(index, activePage, limit)}
                    </td>

                    <td className="nowrap text-center">
                      {mapProp?.name || "---"}
                    </td>

                    <td className="nowrap text-center">
                      {mapProp?.discountPercentage || 0}%
                    </td>

                    <td className="nowrap text-center">
                      {mapProp?.totalProduct || 0}
                    </td>

                    <td className="nowrap text-center">
                      <div className="button-container">
                        <button
                          type="button"
                          onClick={() => {
                            setSelectedProductDetail(mapProp);

                            setEditNewProductTypeState(true);
                          }}
                        >
                          <FaEdit />
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            setDeleteModal(true);
                            setSelectedProductDetail(mapProp);
                          }}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <NotFound
                cols={7}
                msg={"Banner data not found"}
                onHide={onHide}
              />
            )}
          </tbody>
        </table>
      </div>

      {/* --------add Product Type Component */}

      {addNewProductTypeState && (
        <AddNewProductType
          addNewProductTypeState={addNewProductTypeState}
          fetchProductList={fetchProductList}
          closeModel={closeModel}
        />
      )}

      {/* --------edit Product Type */}

      {editNewProductTypeState && (
        <EditProductType
          editNewProductTypeState={editNewProductTypeState}
          fetchProductList={fetchProductList}
          closeModel={closeModel}
          selectedProductDetail={selectedProductDetail}
        />
      )}

      {/* Delete Brand Modal */}
      {deleteModal && (
        <DeleteProductType
          deleteModal={deleteModal}
          selectedProductDetail={selectedProductDetail}
          fetchProductList={fetchProductList}
          closeModel={closeModel}
        />
      )}

      {/* -------------pagination */}
      {total > limit && (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductTypeComponent;